import { useEffect, useRef } from "react";
import { sanitizeHtml } from '../../../util/sanitizeHtml';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux'
import { updateAlertMessage } from "../../../api-integration/commonSlice";


const Alert = () => {
  const dispatch = useDispatch();
  const timeoutIdRef = useRef<any>(null);

  const alertMessage = useSelector((state: any) => state.commonSlice.alertMessage);
  const { user } = useSelector((state: any) => state.commonSlice);
  const timeoutValue = alertMessage.timeout || user?.usrMessageAlertDuration || Number(process.env.REACT_APP_ALERT_TIMEOUT);

  //const timeoutValue = alertMessage.timeout || Number(process.env.REACT_APP_ALERT_TIMEOUT);

  const closeAlert = () => {
    dispatch(updateAlertMessage({ status: '', message: '' }));
  }

  useEffect(() => {
    // Clear any existing auto-close timer.
    // This ensures that when a new alert arrives (especially a manual-dismiss one),
    // any previous timer does not close or interfere with the new alert.
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }

    // If manual dismiss → do not set timeout
    if (alertMessage.isManualDismiss) {
      return;
    }
    timeoutIdRef.current = setTimeout(closeAlert, timeoutValue);
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, [alertMessage.message, alertMessage.status, timeoutValue]);

  return (
    <div className="alert-container">
      {
        alertMessage.status === 'success' &&
        <div 
          key={alertMessage.message} 
          className="alert alert-primary alert-dismissible fade show" 
          role="alert"
        > 
          <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(alertMessage?.message) }}  />
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={closeAlert}></button>
        </div>
      }
      {
        alertMessage.status === 'error' &&
        <div 
          key={alertMessage.message}
          className="alert alert-danger alert-dismissible fade show" 
          role="alert"
        >
           {/*pleaseReload.message  */}
          <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(alertMessage?.message !== "" ? alertMessage?.message : "Please reload the page") }}  />
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={closeAlert}></button>
        </div>
      }
    </div>
  )
}

export default Alert;